import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import { PDFViewer, Document, Page, StyleSheet, Text, View, Link, PDFDownloadLink} from "@react-pdf/renderer";


const useStyles = makeStyles((theme) => ({
    media: {
      padding: 0,
      paddingTop: 10,
        height: '100vh',
        width: '100vw',
        scale: '0.5',
        [theme.breakpoints.down(780)]: {
          height: '100vh',
          width: '100vw',
          padding: 5,
        }
    },
    extendedIcon: {
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
      zIndex: 10000,
  },
}));

// backgroundColor: "#E4E4E4
  // Create styles
  const styles = StyleSheet.create({
    page: {
      flexDirection: "row",
      backgroundColor: "white",
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
    },
    section: {
      margin: 30,
      padding: 10,
      flexGrow: 1,
    },
    title: {
      textAlign: 'center',
      fontSize: '15',
      margin: 10,
    },
    additionalInfo: {
      fontSize: '12',
      textAlign: 'center',
      margin: 5,
    },
    subTitle: {
      textAlign: 'left',
      fontSize: '14',
      margin: 10,
    },
    answers: {
      flexDirection: "row",
      textAlign: 'right',
      margin: 5,
    },
    results: {
      textAlign: 'right',
      margin: 5,
      fontSize:'12',
    },
    question: {
      fontSize: '12',
      textAlign: 'left',
      margin: 5,
    },
    explanation: {
      fontSize: '10',
      textAlign: 'left',
      margin: 5,
    },
    selectedAnswer: {
      fontSize: '12',
      textAlign: 'right',
      margin: 5,
    },
    unselectedText: {
      backgroundColor: '#D3D3D3',
      display: 'inline',
      width: '75px',
      fontSize: '10',
      textAlign: 'center',
      margin: 5,
      padding: 2,
      height:20,
    },
    selectedText: {
      backgroundColor: 'grey',
      display: 'inline',
      width: '75px',
      fontSize: '10',
      textAlign: 'center',
      margin: 5,
      padding: 2,
      height:20,
    },
  });


export default function ADHDChildhoodPDF(props) {
  const classes = useStyles();

  function displayQuestions(surveyData, addToIndex) {
    return surveyData.map((question,index)=>{
       return <React.Fragment key={question.text}>
       <Text style={styles.question} key={question.text}>{index+addToIndex}) {question.text}</Text>
       <View style={styles.answers} key={question.answers}>
          {displayAnswers(question)}
       </View>
       <Text style={styles.explanation}>Explanation: {question.explanation}</Text>
       </React.Fragment>
  });
  }

  function displayAnswers(question) {
    if (props.displayData.type==="select") {
      return <Text style={styles.selectedAnswer} key={question}>{question.answers[question.choice]}, {question.choice}</Text>;
    }
    
    return question.answers.map((answer,index)=>{
        if (index===question.choice) {
            return <Text style={styles.selectedText} key={answer}>{answer}</Text>
        }
        return <Text style={styles.unselectedText} key={answer}>{answer}</Text>
    });
  }

  // Displays sub scores when given survey data
function showScoreData() {
    return props.scoreData.map((scoreType)=><Text style={styles.results} key={scoreType.name}>{scoreType.name} {scoreType.score}</Text>);
}
  
  const documentPDF = <>
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
        <Text style={styles.title}>{props.displayData.title}</Text>
          <Text style={styles.additionalInfo}>{props.displayData.subTitle}</Text>
          <Text style={styles.subTitle}>{props.displayData.sectionTitles[0]}</Text>
          <Text style={styles.additionalInfo}>{props.displayData.sectionSubTitles[0]}</Text>
          {displayQuestions(props.surveyPartA, 1)}
          <Text style={styles.subTitle}>{props.displayData.sectionTitles[1]}</Text>
          <Text style={styles.additionalInfo}>{props.displayData.sectionSubTitles[1]}</Text>
          {displayQuestions(props.surveyPartB, props.surveyPartA.length+1)}
          {showScoreData()}
          <Text style={styles.additionalInfo}>Document Generated on <Link src="https://psych-apps.web.app/">Fantes.MD Psych Apps</Link> on {new Date().toLocaleDateString("en-US")}</Text>
          <Text style={styles.additionalInfo}><Link src="https://psych-apps.web.app/">https://psych-apps.web.app/</Link></Text>
          <Text style={styles.additionalInfo}>For Personal Use Only</Text>
        </View>
      </Page>
    </Document>
  </>;

  return <><div>
    <div className={classes.extendedIcon}>
      <Fab variant="extended" color="secondary" type="button">
        <PDFDownloadLink document={documentPDF} fileName={`${props.displayData.title} - ${new Date().toLocaleDateString("en-US")}.pdf`}>
      {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download PDF')}
      </PDFDownloadLink>
    </Fab>{" "}
    <Fab variant="extended" type="button" onClick={props.onReturnClick}>Return To Survey</Fab>
    </div>
    <PDFViewer className={classes.media}>
      {documentPDF}
    </PDFViewer>
    </div>
    </>;
  }